/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { ImageCover } from "cms/images/image-cover/image-cover";
import { formatBytes } from "utils/format-bytes";
import { Button } from "@mui/material";
import { getDimensionsText, getFileTypeName, formatDate } from "cms/images/image-selector/image-helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "cms/icons";
const { faBoxArchive } = regular;
const { faRepeat } = solid;

const ImageDialogPreviewPanel = () => {
    const imageEditContext = useContext(ImageEditContext);
    const selectedImage = imageEditContext?.selectedImage;
    const setIsArchiving = imageEditContext?.setIsArchiving;
    const setIsReplacing = imageEditContext?.setIsReplacing;
    const setLocalState = imageEditContext?.setLocalState;
    
    const [imageUrl, setImageUrl] = useState("");
    const hasImage = !!imageUrl;

    const hasSelectedImage = !!selectedImage;

    const file_type = selectedImage?.file_type;
    const file_ext = selectedImage?.file_ext;
    const file_size = selectedImage?.file_size;
    const created_at = selectedImage?.created_at;
    const updated_at = selectedImage?.updated_at;

    const formatedCreatedDate = formatDate(created_at);
    const formatedUpdatedDate = formatDate(updated_at);
    const fileTypeName = getFileTypeName(file_type);
    const formatedBytes = formatBytes(file_size);
    const dimensionText = getDimensionsText(selectedImage);
    const selectedUrl = `${selectedImage?.url}?t=${Date.now()}`;

    const handleOpenReplace = () => {
        setIsReplacing(true);
    };

    const handleOpenArchive = () => {
        setIsArchiving(true);
    };

    useEffect(() => {
        if (hasSelectedImage) {
            setImageUrl(selectedUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasSelectedImage]);

    useEffect(() => {
        setLocalState({
            image: selectedImage,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedImage]);


    return (
        <Fragment>
            {!hasImage &&
                <div className="simplicity-image-selector-window-preview-none">
                    No image selected
                </div>
            }

            {hasImage &&
                <div className="simplicity-image-selector-window-preview left-side dialog-edit-resize">
                    <div className="simplicity-image-selector-preview">
                        <div className='image-details-cover image-cover-left'>
                            {hasSelectedImage &&
                                <>
                                    <ImageCover
                                        displayWidth={232}
                                        displayHeight={186}
                                    />

                                    <a
                                        href={selectedUrl}
                                        target='_blank'
                                        className="view-image-link"
                                        rel='noopener noreferrer'
                                    >
                                            View image
                                    </a>
                                </>
                            }
                        </div>

                        <div className='image-selector-properties image-selector-properties-btns'>
                            {hasSelectedImage &&
                                <>
                                    <div>
                                        <span>Type:</span> {fileTypeName} ({file_ext})
                                    </div>
                                    <div><span>Size:</span> {formatedBytes}</div>
                                    <div><span>Dimensions:</span> {dimensionText}</div>
                                    <div className="button-container action-btns">
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            onClick={handleOpenReplace}
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={faRepeat}
                                                />
                                            }
                                        >
                                            Replace
                                        </Button>
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            onClick={handleOpenArchive}
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={faBoxArchive}
                                                />
                                            }
                                        >
                                            Archive
                                        </Button>
                                    </div>
                                    <div><span>Uploaded:</span> {formatedCreatedDate}</div>
                                    <div><span>Modified:</span> {formatedUpdatedDate}</div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export { ImageDialogPreviewPanel };
